<template>
    <div class="detailCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-8 col-md-8">

                    <v-text-field color="secondary" label="*Empresa" placeholder="Ingrese el nombre de la empresa"
                        :counter="40" :maxlength="40" required :rules="companyNameRules"
                        v-model="formData.companyName"></v-text-field>

                    <v-select color="secondary" label="*Tipo Identificación"
                        placeholder="Selecciona un tipo de identificación" required :items="typeIdentification"
                        item-text="identificationType" item-value="identificationId" :rules="tipoIdentificacionRules"
                        v-model="formData.identificationId"></v-select>


                    <v-text-field color=secondary label="*Número Identificación"
                        placeholder="Ingrese el número de identificación" required :counter="19" :maxlength="19"
                        :rules="identificationNumberRules" v-model="formData.identificationNumber"
                        @input="formatIdentificationNumber" @keydown="handleKeyDown" inputmode="numeric"></v-text-field>

                    <v-text-field color=secondary label="*Nombre Contacto" placeholder="Ingrese nombre de contacto"
                        :counter="100" :maxlength="100" required :rules="contactNameRules"
                        v-model="formData.contactName"></v-text-field>


                    <v-text-field color="secondary" label="*Teléfono" placeholder="Ingrese el número de contacto"
                        required :rules="[...phoneRules, phoneLengthRule]" v-model="formData.contactNumber"
                        @keydown="handleKeyPhoneDown" inputmode="numeric" pattern="[0-9]{0,10}" :counter="15"
                        :maxlength="15"></v-text-field>

                    <v-text-field color=secondary label="*Correo" placeholder="Ingrese un correo" required
                        :rules="emailRules" :counter="200" :maxlength="200" v-model="formData.email"></v-text-field>

                    <v-text-field v-if=disablePorcentaje color=secondary label="*Comisión"
                        placeholder="Ingrese la comisión" required :rules="porcentajeComisionRules"
                        v-model="formData.porcentajeComision" @blur="formatporcentajeComisionInput" suffix="%"
                        @keydown="handleKeyDown" inputmode="numeric"></v-text-field>

                    <v-text-field label="*Tarifa afiliado" color="primary" placeholder="Ingrese la tarifa afiliado"
                        required v-model="formData.afiliateFee" @keydown="handleKeyDown" @blur="handleBlur" type="text"
                        :rules="valorTarifaAfiliadoRules" clearable></v-text-field>
                </v-form>

                <div class="image-container">
                    <div>
                        <changeImage :image="this.company.icon" />
                    </div>
                    <div class="img-btn">

                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>Seleccionar una Imagen</span>
                        </v-tooltip>

                        <input type="file" @change="onFileChange" id="file-input" accept="image/*"
                            style="display: none" />

                        <v-tooltip left>

                            <template v-slot:activator="{ attrs }">

                                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs"
                                    @click="submitForm">
                                    <v-icon dark>mdi-content-save</v-icon>
                                </v-btn>

                            </template>

                            <span>Actualizar Empresa</span>

                        </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-btn">
            <div class="btn">
                <addUserAdmin :addUsersAdminCompany="company" />

            </div>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";
import addUserAdmin from "@/views/users_admin/pages/add_users_admin/add_users_admin_page.vue";

import {
    COMPANIES_M,
    GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_PUT_UPDATE_COMPANIES,
    ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_GET_COMPANY_BY_ID,
    GET_STATE_LOADING,
} from "@/views/companies/store/types/types.js";

import {
    USERSADMIN_M,
    ACTION_GET_USERSADMIN_COMPANY_ID,
} from "@/views/users_admin/store/types/types.js";

import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {
        changeImage,
        addUserAdmin

    },
    name: "detailCompaniesComponent",
    props: {
        company: {
            required: true
        },

        disablePorcentaje: {
            required: true
        }

    },

    data() {
        return {
            formData: {
                companyId: this.company.companyId,
                companyName: this.company.name,
                identificationId: this.company.identificationId,
                identificationNumber: this.company.identificationNumber,
                contactName: this.company.contactName,
                contactNumber: this.company.contactNumber,
                email: this.company.email,
                porcentajeComision: this.porcentajeComisionInput(this.company.porcentajeComision),
                imageFile: this.company.icon,
                afiliateFee: this.company?.afiliateFee ?? null,
            },



            // imageFile: null, // Estado local para almacenar la URL de la imagen seleccionada

            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],
            companyNameRules: [
                v => !!v || "Empresa requerida",
                v => (v && v.length <= 40) || "El nombre no puede tener más de 40 caracteres",
            ],
            tipoIdentificacionRules: [
                v => !!v || "Tipo identificación requerido"
            ],
            identificationNumberRules: [
                v => !!v || "Número identificación requerido"
            ],
            contactNameRules: [
                v => !!v || "Nombre contacto requerido",
                v => (v && v.length <= 100) || "Nombre contacto no puede tener más de 100 caracteres",
            ],
            phoneRules: [
                v => !!v || "Teléfono requerido",
            ],
            phoneLengthRule: v =>
                (v && v.length >= 7 && v.length <= 15) || "Teléfono debe tener entre 7 y 15 dígitos",

            emailRules: [
                v => !!v || "Correo requerido",
                v => (v && v.length <= 200) || "Correo no puede tener más de 200 caracteres",
                v => emailRegex.test(v) || "El formato del correo es inválido"
            ],

            porcentajeComisionRules: [
                v => !!v || 'Comisión requerida',
                v => this.validatePercentage(v) || 'Comisión debe ser entre 1 y 10',
                v => {

                    const number = parseFloat(v);
                    if (number < 1 || number > 10) {
                        return 'Comisión debe ser entre 1 y 10';
                    }

                    return true;
                }
            ],

            valorTarifaAfiliadoRules: [
                v => !!v || "La tarifa afiliado es requerido",
                v => parseFloat(v.replace(/[$,]/g, '')) > 0 || 'El valor debe ser mayor a $0.00',

            ],

            showErrorMessages: false,
            emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            companyUpdate: null,
        };
    },

    async mounted() {

        this.getActionuserAdminComanyId(this.company.companyId);
        this.getActionTypeIdentification();

    },

    computed: {
        ...mapGetters({
            loading: [`${COMPANIES_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${COMPANIES_M}${GET_COMPANIES_LIST_TYPE_DOCUMENT}`]
        }),

        // Propiedad computada para convertir formData.urlImagenEmpresa en imageUrl
        imageUrl() {
            return this.formData.imageFile;
        },
    },

    methods: {

        ...mapActions({
            putActionActualizarCompany: `${COMPANIES_M}${ACTION_PUT_UPDATE_COMPANIES}`,
            getActionTypeIdentification: `${COMPANIES_M}${ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT}`,
            getActionCompanyById: `${COMPANIES_M}${ACTION_GET_COMPANY_BY_ID}`,
            getActionuserAdminComanyId: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_COMPANY_ID}`,
        }),

        async reloadUserAdminId() {
            await this.getActionuserAdminComanyId(this.userAdminId.userId);
        },

        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },
        handleBlur() {
            if (this.formData.afiliateFee) {
                const numberValue = parseFloat(this.formData.afiliateFee.replace(/[^0-9.]/g, ''));
                if (!isNaN(numberValue)) {
                    this.formData.afiliateFee = this.formatNumber(numberValue);
                } else {
                    this.formData.afiliateFee = '';
                }
            }
        },

        formatNumber(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        handleKeyPhoneDown(event) {
            const allowedKeys = /^[0-9()-]$/; // Expresión regular que permite números, espacios, paréntesis y guiones medios

            // Permitir solo las teclas que coinciden con la expresión regular o la tecla de borrar
            if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        validatePercentage(value) {
            if (!value) {
                return false;
            }

            const numericValueStr = value.toString().replace(',', '.');

            if (numericValueStr.endsWith('.')) {
                return false;
            }

            if (numericValueStr.startsWith('.')) {
                return false;
            }

            if (numericValueStr.split('.').length - 1 > 1) {
                return false;
            }

            const parts = numericValueStr.split('.');
            const decimalPart = parts[1];

            if (decimalPart && decimalPart.length > 2) {
                return false;
            }

            const numericValue = parseFloat(numericValueStr);

            return numericValue >= 1 && numericValue <= 10;
        },

        formatporcentajeComisionInput() {
            let input = this.formData.porcentajeComision;

            if (input == null) {
                this.formData.porcentajeComision = '';
                return;
            }

            let number = input.trim().replace(/[^\d]/g, '');

            if (number === '') {
                this.formData.porcentajeComision = '';
                return;
            }

            let numericValue = parseFloat(number);

            let formattedNumber = '';

            if (numericValue <= 10) {
                formattedNumber = numericValue.toFixed(1);
            } else if (numericValue > 10 && numericValue < 100) {
                formattedNumber = (numericValue / 10).toFixed(1);
            }

            let finalNumber = parseFloat(formattedNumber);
            if (isNaN(finalNumber) || finalNumber < 1 || finalNumber > 10) {
                this.formData.porcentajeComision = '';
                return;
            }

            this.formData.porcentajeComision = formattedNumber;
        },

        porcentajeComisionInput(number) {
            // Convertir el número en string y eliminar caracteres no numéricos
            let numStr = String(number).trim().replace(/[^\d.]/g, '');

            if (numStr === '') {
                return '';
            }

            // Separar parte entera y decimal
            let [integerPart, decimalPart] = numStr.split('.');

            // Asegurarse de que la parte entera no sea vacía
            if (integerPart === '') {
                integerPart = '0';
            }

            // Limitar la parte decimal a 2 dígitos
            if (decimalPart !== undefined) {
                decimalPart = decimalPart.slice(0, 2);
            }

            // Formatear la parte entera
            let formattedNumber = '';
            while (integerPart.length > 0) {
                formattedNumber = integerPart.slice(-2) + formattedNumber;
                integerPart = integerPart.slice(0, -2);

                if (integerPart.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Añadir la parte decimal si existe
            if (decimalPart !== undefined) {
                formattedNumber += '.' + decimalPart;
            }

            return formattedNumber;
        },

        // Método para manejar el cambio de archivo
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.imageFile = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.company.icon = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.imageFile.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
                });
            }
        },

        async submitForm() {
            try {

                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'

                });
                if (result.isConfirmed) {

                    // Validar el formulario antes de enviarlo
                    const validationErrors = this.validateForm();

                    // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    // Si no hay errores de validación, imprime el formulario en la consola
                    const save = await this.putActionActualizarCompany(this.formData);
                    if (!save) {

                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        })

                    }


                } else {

                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }

                EventBus.$emit('reload-update-company');

            } catch (error) {
                console.error("Fallo al actualizar")
            }

        },

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;

            // Expresión regular para validar que no consista solo en espacios en blanco o tabulaciones
            const notOnlyWhitespaceRegex = /\S/;

            const errors = {};

            if (!this.formData.companyName || !this.formData.companyName.trim() || this.formData.companyName.length > 40) {
                errors.companyName = 'Empresa';
            }

            if (!this.formData.identificationId) {
                errors.identificationId = 'Tipo Identificación';
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = 'Número Identificación';
            }

            if (!this.formData.contactName || !notOnlyWhitespaceRegex.test(this.formData.contactName) || this.formData.contactName.length > 100) {
                errors.contactName = 'Nombre Contacto';
            }

            if (!this.formData.contactNumber || !/^[0-9\s()-]{7,15}$/.test(this.formData.contactNumber)) {
                errors.contactNumber = 'Teléfono';
            }

            if (!this.formData.email || !emailRegex.test(this.formData.email) || this.formData.email.length > 50) {
                errors.email = 'Correo';
            }

            if (!this.formData.porcentajeComision || !this.validatePercentage(this.formData.porcentajeComision)) {
                errors.porcentajeComision = 'Comisión';
            }

            if (!this.formData.afiliateFee || this.formData.afiliateFee === '$0.00') {
                errors.afiliateFee = 'Tarifa afiliado';
            }

            if (!this.formData.imageFile) {
                errors.imageFile = 'Logo';
            }

            return errors;
        },

    },



};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* Alineación vertical */
}

.img-btn {
    margin-top: 20px;
    /* Espacio entre el componente changeImage y el botón de seleccionar imagen */
}

.user-btn {
    position: absolute;
    top: 20px;
    /* Posicionamiento en la parte superior */
    right: 20px;
    /* Posicionamiento a la derecha */
}

/*Resposive*/

@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .image-container {
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .col-md-7 {
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }

    .user-btn {
        position: static;
        margin-top: 20px;
    }
}
</style>